import { useEffect, useState } from 'react';
import { ContactTaskMeContent, ContactTaskMeItem } from './styles';

interface Taskme {
    id: number,
    icon: string,
    title: string,
    description: string,
    link: string
}

export function ContactTaskMe() {
    const [listTasks, setListTasks] = useState<Taskme[]>([]);

    useEffect(() => {
        fetch('./services/taskme.json', {
            headers: {
                Accept: 'application/json'
            }
        }).then(response => response.json())
            .then(data => setListTasks(data.taskMe))
    }, [])

    return (
        <ContactTaskMeContent>
            <h3>Fale comigo</h3>
            {listTasks.map((task) => {
                return (
                    <ContactTaskMeItem key={task.id}>
                        <i className={task.icon}></i>
                        <h4>{task.title}</h4>
                        <p>{task.description}</p>
                        <a href={task.link} target="_blank" rel="noopener noreferrer">
                            Escreva-me
                            <i className="uil uil-arrow-right"></i>
                        </a>
                    </ContactTaskMeItem>
                )
            })}
        </ContactTaskMeContent>
    )
}